export enum EMessageType {
    AlternativeResource = "AlternativeResource",
    ResourceConflict = "ResourceConflict",
    MoveOrder = "MoveOrder",
}